import AskStore from './AskStore';
import AuthenticationStore from './AuthenticationStore';
import FaqStore from './FaqStore';
import CommunicationNoticeStore from './CommunicationNoticeStore';
import NotificationStore from './NotificationStore';
import PostStore from './PostStore';
import ProductStore from './ProductStore';
import QuestionNoticeStore from './QuestionNoticeStore';
import QuestionStore from './QuestionStore';
import SearchStore from './SearchStore';
import SaleStore from './SaleStore';
import DocumentStore from './DocumentStore';
import CourseStore from './CourseStore';

export default {
  AskStore,
  AuthenticationStore,
  FaqStore,
  CommunicationNoticeStore,
  NotificationStore,
  PostStore,
  ProductStore,
  QuestionNoticeStore,
  QuestionStore,
  SearchStore,
  SaleStore,
  DocumentStore,
  CourseStore
};



// WEBPACK FOOTER //
// ./src/stores/index.js